<div class="row justify-content-center spacer">
    <span class="icon-quote"></span>
    <div class="col-md-8">
        <q>{{context.quote}}</q>
        <span class="txt-by">{{context.by}}</span>
        <span class="txt-occupation">{{context.occupation}}</span>
    </div>
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/quote/quote.component.html